import React, { useState } from "react";
import { Formik } from "formik";
import Inputbox from "./Inputbox";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreators from "../store/actionCreators/index";
import { useNavigate } from "react-router-dom";

const PasswordUpdate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  console.log(state, "PasswordUpdate");
  return (
    <div className="flex gap-16">
      <div>
        <h1 className="font-[500] text-lg">Update Password</h1>
        <p className="text-sm text-greySecondary">
          Secure your account using a strong password to stay secure.
        </p>
      </div>
      <Formik
        initialValues={{
          old_password: "",
          new_password: "",
        }}
        onSubmit={(values) => {
          dispatch(
            actionCreators.editPassword(
              state.user.id,
              navigate,
              values,
              setLoading,
              state.token
            )
          );
          console.log(values);
        }}
      >
        {(props) => (
          <form onSubmit={props.handleSubmit}>
            <div className="flex gap-2 mb-2 items-center justify-between">
              <Inputbox
                onChange={props.handleChange}
                type="password"
                name="old_password"
                placeholder="********"
                title="Current password"
              />
              <Inputbox
                onChange={props.handleChange}
                type="password"
                name="new_password"
                placeholder="********"
                title="New Password"
              />
            </div>
            <div className="flex gap-2 mb-2 items-center justify-between">
              {/* <div className="flex-1">
                <Inputbox
                  onChange={props.handleChange}
                  type="password"
                  name="firstname"
                  placeholder="********"
                  title="Confirm New password"
                />
              </div> */}

              <div className="flex-1 self-end">
                <button
                  type="submit"
                  className="bg-darkPrimary ml-auto block w-[5rem] p-2 rounded-lg text-white font-[500] text-base"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default PasswordUpdate;
